import type { ProjectResponseBasicInfoVisibility } from './projectResponseBasicInfoVisibility';

/**
 * 프로젝트 기본 정보
 */
export type ProjectResponseBasicInfo = {
  createdAt?: string;
  description?: string;
  /** 프로젝트 ID (Snowflake ID) */
  id?: number;
  title?: string;
  updatedAt?: string;
  visibility?: ProjectResponseBasicInfoVisibility;
};
